module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8023.7412f242.png";